// くちびるLABO カードデータ
// カードの視覚要素（背景色、番号ラベル、タイトル、波線、イラスト）は
// image に指定された画像に焼き付け済み。
// title / description は将来のモーダル本文で参照する用途。

export const laboCards = [
	{
		id: 'labo-01',
		modalId: 'modal-labo-01',
		number: '#01',
		title: '実は 85%の人が、「くちびる」に悩みがある！?',
		description: 'ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。',
		image: './assets/images/labo/labo_01.webp',
	},
	{
		id: 'labo-02',
		modalId: 'modal-labo-02',
		number: '#02',
		title: 'くちびるの3大悩み "質感・色・形" とその原因とは',
		description: 'ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。',
		image: './assets/images/labo/labo_02.webp',
		recommend: {
			groups: [
				{
					label: '気になる乾燥によるダメージに',
					series: 'medicated',
					products: [
						{ id: 'medicated-regular', thumb: './assets/images/labo/modal-02/products/medicated-regular.webp' },
						{ id: 'medicated-sensitive', thumb: './assets/images/labo/modal-02/products/medicated-sensitive.webp' },
						{ id: 'botanical', thumb: './assets/images/labo/modal-02/products/botanical.webp' },
						{ id: 'extra-moisture', thumb: './assets/images/labo/modal-02/products/extra-moisture.webp' },
					],
				},
				{
					label: '血色感を補い紫外線対策ができる',
					series: 'color',
					products: [
						{ id: 'sheer-orange-beige', thumb: './assets/images/labo/modal-02/products/sheer-orange-beige.webp' },
						{ id: 'sheer-brown-beige', thumb: './assets/images/labo/modal-02/products/sheer-brown-beige.webp' },
						{ id: 'sheer-rose-pink', thumb: './assets/images/labo/modal-02/products/sheer-rose-pink.webp' },
						{ id: 'sheer-red', thumb: './assets/images/labo/modal-02/products/sheer-red.webp' },
						{ id: 'sheer-bordeaux', thumb: './assets/images/labo/modal-02/products/sheer-bordeaux.webp' },
					],
				},
			],
		},
	},
	// {
	// 	id: 'labo-03',
	// 	modalId: 'modal-labo-03',
	// 	number: '#03',
	// 	title: '実はお肌よりもデリケート！くちびるを特別にケアしてあげるべき理由とは',
	// 	description: 'ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。',
	// 	image: './assets/images/labo/labo_03.webp',
	// 	recommend: {
	// 		heading: 'このお悩みにおすすめのDHCのリップクリーム',
	// 		groups: [
	// 			{
	// 				label: 'デリケートな唇をやさしくケア。',
	// 				series: 'medicated',
	// 				products: [
	// 					{ id: 'medicated-regular', thumb: './assets/images/labo/modal-02/products/medicated-regular.webp' },
	// 					{ id: 'medicated-sensitive', thumb: './assets/images/labo/modal-02/products/medicated-sensitive.webp' },
	// 					{ id: 'botanical', thumb: './assets/images/labo/modal-02/products/botanical.webp' },
	// 					{ id: 'extra-moisture', thumb: './assets/images/labo/modal-02/products/extra-moisture.webp' },
	// 				],
	// 			},
	// 			{
	// 				label: '血色感を補い紫外線対策ができる',
	// 				series: 'color',
	// 				products: [
	// 					{ id: 'sheer-orange-beige', thumb: './assets/images/labo/modal-02/products/sheer-orange-beige.webp' },
	// 					{ id: 'sheer-brown-beige', thumb: './assets/images/labo/modal-02/products/sheer-brown-beige.webp' },
	// 					{ id: 'sheer-rose-pink', thumb: './assets/images/labo/modal-02/products/sheer-rose-pink.webp' },
	// 					{ id: 'sheer-red', thumb: './assets/images/labo/modal-02/products/sheer-red.webp' },
	// 					{ id: 'sheer-bordeaux', thumb: './assets/images/labo/modal-02/products/sheer-bordeaux.webp' },
	// 				],
	// 			},
	// 		],
	// 	},
	// },
	// {
	// 	id: 'labo-04',
	// 	modalId: 'modal-labo-04',
	// 	number: '#04',
	// 	title: 'くちびるの内側で起きている "老化の真実"',
	// 	description: 'ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。',
	// 	image: './assets/images/labo/labo_04.webp',
	// 	recommend: {
	// 		heading: 'このお悩みにおすすめのDHCのリップクリーム',
	// 		groups: [
	// 			{
	// 				label: 'ボリュームが気になる唇に',
	// 				series: 'medicated',
	// 				products: [
	// 					{ id: 'extra-moisture', thumb: './assets/images/labo/modal-02/products/extra-moisture.webp' },
	// 				],
	// 			},
	// 			{
	// 				label: '唇に自然な血色感を与えてくれる',
	// 				series: 'color',
	// 				products: [
	// 					{ id: 'sheer-orange-beige', thumb: './assets/images/labo/modal-02/products/sheer-orange-beige.webp' },
	// 					{ id: 'sheer-brown-beige', thumb: './assets/images/labo/modal-02/products/sheer-brown-beige.webp' },
	// 					{ id: 'sheer-rose-pink', thumb: './assets/images/labo/modal-02/products/sheer-rose-pink.webp' },
	// 					{ id: 'sheer-red', thumb: './assets/images/labo/modal-02/products/sheer-red.webp' },
	// 					{ id: 'sheer-bordeaux', thumb: './assets/images/labo/modal-02/products/sheer-bordeaux.webp' },
	// 				],
	// 			},
	// 		],
	// 	},
	// },
	// {
	// 	id: 'labo-05',
	// 	modalId: 'modal-labo-05',
	// 	number: '#05',
	// 	title: 'ぷるぷるくちびるを守るためのケア方法',
	// 	description: 'ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。',
	// 	image: './assets/images/labo/labo_05.webp',
	// 	recommend: {
	// 		heading: 'このお悩みにおすすめのDHCのリップクリーム',
	// 		groups: [
	// 			{
	// 				label: 'オリーブオイル配合で、うるおう唇に',
	// 				series: 'medicated',
	// 				products: [
	// 					{ id: 'medicated-regular', thumb: './assets/images/labo/modal-02/products/medicated-regular.webp' },
	// 					{ id: 'medicated-sensitive', thumb: './assets/images/labo/modal-02/products/medicated-sensitive.webp' },
	// 					{ id: 'botanical', thumb: './assets/images/labo/modal-02/products/botanical.webp' },
	// 					{ id: 'extra-moisture', thumb: './assets/images/labo/modal-02/products/extra-moisture.webp' },
	// 				],
	// 			},
	// 			{
	// 				label: '血色感を補いながら紫外線対策もできる',
	// 				series: 'color',
	// 				products: [
	// 					{ id: 'sheer-orange-beige', thumb: './assets/images/labo/modal-02/products/sheer-orange-beige.webp' },
	// 					{ id: 'sheer-brown-beige', thumb: './assets/images/labo/modal-02/products/sheer-brown-beige.webp' },
	// 					{ id: 'sheer-rose-pink', thumb: './assets/images/labo/modal-02/products/sheer-rose-pink.webp' },
	// 					{ id: 'sheer-red', thumb: './assets/images/labo/modal-02/products/sheer-red.webp' },
	// 					{ id: 'sheer-bordeaux', thumb: './assets/images/labo/modal-02/products/sheer-bordeaux.webp' },
	// 				],
	// 			},
	// 		],
	// 	},
	// },
	// {
	// 	id: 'labo-06',
	// 	modalId: 'modal-labo-06',
	// 	number: '#06',
	// 	title: '「くちびるの形」に合わせたリップメイクで、より理想的なフォルムに見せる！',
	// 	description: 'ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。ダミーテキストが入ります。',
	// 	image: './assets/images/labo/labo_06.webp',
	// 	recommend: {
	// 		heading: 'このお悩みにおすすめのDHCのリップクリーム',
	// 		groups: [
	// 			{
	// 				label: 'シアーな美発色＆濃密保湿ボリュームアップ',
	// 				series: 'color',
	// 				products: [
	// 					{ id: 'sheer-orange-beige', thumb: './assets/images/labo/modal-02/products/sheer-orange-beige.webp' },
	// 					{ id: 'sheer-brown-beige', thumb: './assets/images/labo/modal-02/products/sheer-brown-beige.webp' },
	// 					{ id: 'sheer-rose-pink', thumb: './assets/images/labo/modal-02/products/sheer-rose-pink.webp' },
	// 					{ id: 'sheer-red', thumb: './assets/images/labo/modal-02/products/sheer-red.webp' },
	// 					{ id: 'sheer-bordeaux', thumb: './assets/images/labo/modal-02/products/sheer-bordeaux.webp' },
	// 				],
	// 			},
	// 		],
	// 	},
	// },
];

export default laboCards;
